export default {
  namespaced: true,
  user_group_selection_option: {
    title: "User Group Selection Options",
    title_history: "User Group Selection Options History",
    user: "User",
    email: "Email",
    groups: "Groups",
    change: "Change",
    select: "Select",
    without_groups: "You don't have any group assigned",
    group: "Group",
    group_old: "Group Previous",
    date: "Date of Change",
    bulk: {
      manage_users: "Manage users",
      modal_title: "Manage users by group",
      selected_groups: "selected group | selected groups",
      manage_hint: "Manage authorized users before applying changes.",
      current_users: "Users in groups",
      currently_authorized: "Currently authorized",
      remove_all: "Remove all",
      loading: "Loading...",
      remove_user: "Remove user",
      no_current_users: "There are no current users.",
      users_to_add: "Users to add",
      pending_add: "Pending addition",
      clear_add: "Clear \"users to add\"",
      cancel_add: "Cancel addition",
      no_users_to_add: "There are no users to add.",
      users_to_remove: "Users to remove",
      pending_remove: "Pending removal",
      clear_remove: "Clear \"users to remove\"",
      undo: "Undo",
      no_users_to_remove: "There are no users to remove.",
      users: "Users",
      search_users_hint: "Find one or more users and choose whether to add or remove them.",
      selected_users: "selected user | selected users",
      clear: "Clear",
      add_selected: "Add selected users",
      remove_selected: "Remove selected users",
      profile: "Profile",
      profile_hint: "Manage all users belonging to the selected profile.",
      select_profile: "Select profile",
      selected_profile: "Selected profile:",
      remove_profile_single_hint: "Only users already in the group will be considered for removal.",
      remove_profile_multiple_hint: "All users in the profile will be considered for removal.",
      profile_add_to_add: "Move to \"users to add\"",
      profile_remove_from_add: "Remove from \"users to add\"",
      profile_add_to_remove: "Move to \"users to remove\"",
      profile_remove_from_remove: "Remove from \"users to remove\"",
      add_summary: "{count} user will be added to {groups}. | {count} users will be added to {groups}.",
      group_count: "{count} group | {count} groups",
      remove_summary: "{count} user is pending removal. | {count} users are pending removal.",
      apply_changes: "Apply changes",
      user_fallback: "User #{id}",
      all_selected_groups: "All selected groups",
      filters: "Filters",
      clear_filters: "Clear filters",
      apply_filters: "Apply filters",
      search_group: "Search groups...",
      filtering_user: "Filtering by user:",
      user_count: "user | users",
      authorized_users: "Authorized users",
      loading_users: "Loading users...",
      loading_more: "Loading more...",
      users_shown: "{count} of {total} users",
      no_authorized_users: "No authorized users.",
      save_success: "Changes saved successfully",
      save_error: "Unable to save changes",
      filter_hint: "Select a user to show only the groups they can select.",
      active_filter: "Active filter",
      load_error: "Unable to load information",
      attach: "Add users",
      attach_description: "Add the selected users to the allowed groups without removing existing assignments.",
      detach: "Remove users",
      detach_description: "Remove only the selected users from the specified groups.",
    },
  }
}